import { TmApiValidationError } from '@/core/error/transport/tmApiValidationError'

export class TmApiEmailCampaignEmptyRecipientsError extends TmApiValidationError {
  public name = 'TmApiEmailCampaignEmptyRecipientsError'
}
